import Ajaxinate from 'ajaxinate';
export const init = async function(callback) {
    new Ajaxinate({
        container: '#product-grid',
        pagination: '.infinite_next',
        loadingText: 'Loading...',
        callback: callback
    });
};
